import { render, staticRenderFns } from "./OrgPlanCard.vue?vue&type=template&id=6ac2ce99&"
import script from "./OrgPlanCard.vue?vue&type=script&lang=js&"
export * from "./OrgPlanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports